import {
  Component,
  effect,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';
import {
  PatientModel,
  PatientBehaviorAntecedentModel,
  PatientBehaviorConsequenceModel,
} from '../../../../core/api/models';
import { StaffApiService } from '../../../../core/api/services';
import { SupervisorHelperService } from '../../../supervisor.helper.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { Utils } from '../../../../core/utils';

@Component({
  selector: 'app-add-consequence',
  templateUrl: './add-consequence.component.html',
  standalone: false,
})
export class AddConsequenceComponent {
  @Input({ required: true }) patientID!: number;
  consequenceToEdit: PatientBehaviorConsequenceModel | null = null;

  @Output() close = new EventEmitter<void>();

  loading: boolean = false;

  titleName: string = 'Add Consequence';
  actionName: string = 'Add';

  consequenceId: number | null = null;
  name = signal('');
  message = '';
  interval = 0;

  typingTimer: number | undefined;

  constructor(
    private staffApiService: StaffApiService,
    private supervisorHelperService: SupervisorHelperService,
    private alertService: AlertService
  ) {
    // TOUR LOGIC
    effect(() => {
      if (this.name() != '') {
        if (this.typingTimer) {
          clearTimeout(this.typingTimer);
        }
        this.typingTimer = window.setTimeout(() => {
          const event = new Event('name-entered');
          document.getElementById('addConsequenceForm')?.dispatchEvent(event);
        }, 500);
      }
    });
  }

  ngOnInit(): void {
    // EDIT LOGIC
    if (this.supervisorHelperService.consequenceToEdit() != null) {
      this.titleName = 'Edit Consequence';
      this.actionName = 'Save';
      this.consequenceToEdit = this.supervisorHelperService.consequenceToEdit();
      this.consequenceId = this.consequenceToEdit?.ID ?? 0;
      this.name.set(this.consequenceToEdit?.PatientBehaviorConsequence ?? '');
    }
  }

  onCancel() {
    this.close.emit();
  }

  onSubmit() {
    this.loading = true;
    this.staffApiService
      .SavePatientBehaviorConsequence({
        body: {
          ID: this.consequenceId,
          PatientBehaviorConsequence: this.name(),
          PatientID: this.patientID,
        },
      })
      .subscribe(
        (consequence) => {
          console.log(consequence);
          this.loading = false;
          this.alertService.success('Consequence saved successfully');
          this.close.emit();
        },
        (error) => {
          console.error(error);
          this.alertService.error(
            Utils.getErrorMessageFromErrorResponse(error)
          );
          this.loading = false;
          this.close.emit();
        }
      );
  }
}
